<mat-toolbar [class.mat-elevation-z3]="true" [ngClass]="{'drawer-open': showMenu}" class="toolbar">
  <div class="logo-main">
    <a href="https://www.amco-group.co.uk/" target="_blank">
    <img class="logo-size" src="/assets/altlogo.png" alt="AMCO" style="margin-right: 16px;" ></a>
    <div [@rotatedState]='state'>
      <button *ngIf="!showMenu" mat-icon-button (click)="openMenu()">
        <mat-icon>apps</mat-icon>
      </button>
      <button *ngIf="showMenu" mat-icon-button (click)="closeMenu()">
        <mat-icon>apps</mat-icon>
      </button>
    </div>
  </div>
  <span class="spacer"></span>
  <ng-container *ngIf="isChatVisible">
    <ng-container *ngIf="isCustomsListingPage; else defaultToolbarChat">
      <div class="toolbar-chat-pill message-toast"
           [class.active]="isCustomsOpenMessages"
           (click)="HasMessagesFilter()"
           tabindex="0"
           role="button"
           matTooltip="Open customs chats">
        <span class="toolbar-chat-label">Chats</span>
        <span *ngFor="let dto of hasOpenChatsList$ | async" class="toolbar-chat-count">{{ dto.count }}</span>
        <span *ngIf="hasNewCustomsMessages$ | async" class="toolbar-chat-dot"></span>
      </div>
    </ng-container>
    <ng-template #defaultToolbarChat>
      <button mat-button class="toolbar-chat-pill" [class.active]="isManagedChatsActive" (click)="openManagedChats()" matTooltip="Open managed chats">
        <span class="toolbar-chat-label">Chats</span>
        <span *ngFor="let dto of hasOpenChatsList$ | async" class="toolbar-chat-count">{{ dto.count }}</span>
        <span *ngIf="hasNewCustomsMessages$ | async" class="toolbar-chat-dot"></span>
      </button>
    </ng-template>
  </ng-container>
  <button mat-icon-button (click)="logTicket()">
    <mat-icon>confirmation_number</mat-icon>
  </button>
  <button mat-icon-button (click)="clearCacheAndLogout()" matTooltip="Clear cache and logout">
    <mat-icon>clear_all</mat-icon>
  </button>
  <app-switch-tenant *ngIf="tenants?.length > 1" [currentTenant]="currentTenant" [tenants]="tenants" (tenantSelectionChanged)="switchTenant($event)" [theme]="theme"></app-switch-tenant>
  <button *ngIf="signalRConnected; else showDisconnected" mat-icon-button>
    <mat-icon>wifi</mat-icon>
  </button>
  <ng-template #showDisconnected>
    <button (click)="openSignalRDialog()" mat-icon-button>
      <mat-icon>wifi_off</mat-icon>
    </button>
  </ng-template>
  <button mat-icon-button (click)="openProfile()">
    <mat-icon>account_box</mat-icon>
  </button>
</mat-toolbar>
